export default {
  created() {
    this.$OneSignal.on('subscriptionChange', (isSubscribed) => {
      if (isSubscribed && this.$store.getters.user) {
        let userId = this.$store.getters.user.id;
        this.$OneSignal.setExternalUserId(userId);
      }
    });
  }
};